import React from 'react';
import { List } from './dropdown-list';

export class DropDownBtn extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      showDropdown: false
    };
    this.toggleDropdownList = this.toggleDropdownList.bind(this);
  }

  toggleDropdownList () {
    if (!this.state.showDropdown) {
      this.setState({ showDropdown: true });
    } else {
      this.setState({ showDropdown: false });
    }
  }

  render () {
    return (
      <div className={`dropdown-container ${this.props.containerClassName}`}>
        <button
          type="button"
          className={`btn dropdown-btn btn-block ${this.props.buttonClassName}`}
          onClick={this.toggleDropdownList}
        >
          <span className="dropdown-value ellipsis" data-value={this.props.buttonDataValue}>
            {this.props.buttonShownValue}
          </span>
          <span className="down-arrow"></span>
        </button>
        <List
          listKey={this.props.listKey}
          listPreferred={this.props.listPreferred}
          listContent={this.props.listContent}
          listClick={this.props.listClick}
          listData={this.props.listData}
          listClassName={this.props.listClassName}
          listToggle={this.toggleDropdownList}
          isMobile={this.isMobile}
          showDropdown={this.state.showDropdown}
          selectedValue={this.props.buttonDataValue}
        />
      </div>
    );
  }
}
